import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@repo/ui/components/ui/collapsible'
import { ChevronDown, Laptop } from 'lucide-react'
import { useEffect, useState } from 'react'
import { authClient } from '@/lib/auth-client'

export function SecurityTab() {
  const [sessionCount, setSessionCount] = useState(0)

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const sessions = await authClient.listSessions()
        if (sessions.data) setSessionCount(sessions.data.length)
      } catch {
        setSessionCount(0)
      }
    }

    void fetchSessions()
  }, [])

  return (
    <div className="space-y-4">
      <Collapsible defaultOpen>
        <CollapsibleTrigger className="group flex w-full cursor-pointer items-center justify-between rounded-[4px] border border-border bg-card px-4 py-4 text-left">
          <div className="flex items-center gap-3">
            <Laptop className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-sm font-medium">Current device</p>
              <p className="text-sm text-muted-foreground">
                {sessionCount} active {sessionCount === 1 ? 'session' : 'sessions'}
              </p>
            </div>
          </div>
          <ChevronDown className="h-4 w-4 transition-transform group-data-[state=open]:rotate-180" />
        </CollapsibleTrigger>
        <CollapsibleContent className="pt-2">
          <div className="rounded-lg border border-border/60 bg-muted/20 p-4 text-sm text-muted-foreground">
            Session details are managed by your auth provider and refresh automatically. If
            something looks unfamiliar, sign out here and rotate credentials from your identity
            provider.
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  )
}
